import {ContactLabel} from '../enum';
export const labels: Record<'label' | 'value', ContactLabel>[] = [
  {label: ContactLabel.Work, value: ContactLabel.Work},
  {label: ContactLabel.Personal, value: ContactLabel.Personal},
  {label: ContactLabel.Other, value: ContactLabel.Other},
];
